/* 260710 header redesign — search drawer extras:
   recent searches + recently viewed products (localStorage, no external calls) */
(function () {
  var LS_SEARCHES = 'hh:recentSearches';
  var LS_VIEWED = 'hh:recentlyViewed';
  var MAX_SEARCHES = 6;
  var MAX_VIEWED = 4;

  function read(key) {
    try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
  }
  function write(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* private mode */ }
  }

  /* --- capture product visits --- */
  if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+/i.test(location.pathname)) {
    fetch(location.pathname.split('?')[0] + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.handle) return;
        var list = read(LS_VIEWED).filter(function (x) { return x.handle !== p.handle; });
        list.unshift({
          handle: p.handle,
          title: p.title,
          url: p.url || ('/products/' + p.handle),
          image: p.featured_image,
          price: p.price,
          compare: p.compare_at_price,
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
        });
        write(LS_VIEWED, list.slice(0, 8));
      })
      .catch(function () {});
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + (currency || '');
    }
  }

  function renderRecentSearches(box) {
    var terms = read(LS_SEARCHES);
    var list = box.querySelector('.search-drawer_chips');
    if (!terms.length || !list) { box.hidden = true; return; }
    list.innerHTML = '';
    terms.forEach(function (t) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '/search?q=' + encodeURIComponent(t);
      a.textContent = t;
      li.appendChild(a);
      list.appendChild(li);
    });
    box.hidden = false;
  }

  function renderRecentlyViewed(box, extras) {
    var items = read(LS_VIEWED).slice(0, MAX_VIEWED);
    var list = box.querySelector('.search-drawer_cards');
    if (!items.length || !list) { box.hidden = true; return; }
    list.innerHTML = '';
    items.forEach(function (p) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = p.url;
      var imgWrap = document.createElement('div');
      imgWrap.className = 'search-drawer_card-img';
      if (p.image) {
        var img = document.createElement('img');
        /* request a small CDN rendition instead of the multi-MB original */
        img.src = p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=480';
        img.alt = p.title;
        img.loading = 'lazy';
        imgWrap.appendChild(img);
      }
      var title = document.createElement('strong');
      title.className = 'search-drawer_card-title';
      title.textContent = p.title;
      var price = document.createElement('span');
      price.className = 'search-drawer_card-price';
      price.textContent = money(p.price, p.currency);
      a.appendChild(imgWrap);
      a.appendChild(title);
      a.appendChild(price);
      li.appendChild(a);
      list.appendChild(li);
    });
    box.hidden = false;
    /* recently-viewed replaces the featured collection (Vasky behaviour) */
    var featured = extras.querySelector('.search-drawer_featured');
    if (featured) featured.hidden = true;
  }

  function init() {
    document.querySelectorAll('.search-drawer_extras').forEach(function (extras) {
      var recent = extras.querySelector('.search-drawer_recent');
      var viewed = extras.querySelector('.search-drawer_viewed');
      if (recent) renderRecentSearches(recent);
      if (viewed) renderRecentlyViewed(viewed, extras);

      extras.querySelectorAll('.search-drawer_clear').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.dataset.clear === 'searches') {
            write(LS_SEARCHES, []);
            if (recent) recent.hidden = true;
          } else {
            write(LS_VIEWED, []);
            if (viewed) viewed.hidden = true;
            var featured = extras.querySelector('.search-drawer_featured');
            if (featured) featured.hidden = false;
          }
        });
      });
    });

    /* record searches submitted from any search form in the drawer */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.closest || !form.closest('.modal-component--search-drawer')) return;
      var q = form.querySelector('input[name="q"]');
      if (!q || !q.value.trim()) return;
      var term = q.value.trim();
      var list = read(LS_SEARCHES).filter(function (t) {
        return t.toLowerCase() !== term.toLowerCase();
      });
      list.unshift(term);
      write(LS_SEARCHES, list.slice(0, MAX_SEARCHES));
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
